import React from 'react';
import styled from 'styled-components';
import { split } from 'lodash';

const EsReqDoneTrItemBlock = styled.tr``;

const EsReqDoneTrItem = (curitem, index) => {

    const getDscntPercent = (item) => {

        if (item.es_detail_dscnt_per > 0) {
            return (<p><span className="dotted-tag red"><span>{item.es_detail_dscnt_per}</span>%</span></p>);
        } else {
            return ("");
        }
    }

    const getDscntPriceNoDot = (item) => {
        if (item.es_detail_dscnt_per > 0 || item.es_detail_dscnt_price > 0) {
            return (<p className={item.es_detail_add_dscnt_price > 0 ? "sale_plus pink fontsize-14" : "pink fontsize-14"}>
                <span className="font-mont">
                    -{Number(item.es_detail_dscnt_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return ("-");
        }
    }

    const getAddDscntPrice = (item) => {

        if (item.es_detail_add_dscnt_price > 0) {
            return (<p className="pink fontsize-14">
                <span>추가할인</span><br />
                <span className="font-mont">-
                {Number(item.es_detail_add_dscnt_price.toFixed(1)).toLocaleString()}</span>원
            </p>);
        } else {
            return ("");
        }
    }

    const isCashOnDlvryShow = (item) => {
        if (item.es_detail_dlvry_pay_type === '025202') {
            return { display: 'block' };  // 착불 
        } else {
            return { display: 'none' };
        }
    }

    const getCateName = (cate_name) => {

        if (cate_name !== null) {
            let catenames = split(cate_name, '>');
            return catenames[1];
        }

        return "";
    }

    const getDetailDlvry = (item) => {

        if (item.es_detail_dlvry_fee > 0) {
            return (<p className="fontsize-14">
                {Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}원</p>)
        } else {
            return (<div>
                <p className="fontsize-14">무료</p>
            </div>)
        }
    }

    return (
        <EsReqDoneTrItemBlock key={index}>
            <td className="pt_title-box clearfix">
                <div className="product-thumbnail f-left">
                    <div className="ed-front">
                        <img src={curitem.repr_img} alt="" />
                    </div>
                    <div className="ed-back">
                        <a href="#"><span>{getCateName(curitem.cate_name)}</span></a>
                    </div>
                </div>
                <div className="product-title f-left">
                    <p className="pt-title">
                        <a href="#">{curitem.prdct_nm}</a>
                    </p>
                    <div className="pt-option">
                        <p> <span>{curitem.opt_nm}</span></p>
                        <p>수량 : <span>{curitem.qty}</span>개</p>
                    </div>
                </div>
            </td>
            {/* 상품금액 */}
            <td className="text_center">
                {getDscntPercent(curitem)}
                <p className="fontsize-14"><span className="font-mont">
                    {Number(curitem.es_detail_prdct_price.toFixed(1)).toLocaleString()}
                </span>원</p>
            </td>
            {/* 할인금액 */}
            <td className="text_center">
                {getDscntPriceNoDot(curitem)}
                {getAddDscntPrice(curitem)}
            </td>
            {/* 배송비 */}
            <td className="text_center">
                <div style={isCashOnDlvryShow(curitem)}>
                    <p className="fontsize-14 gray-text">착불 배송비</p>
                </div>
                {getDetailDlvry(curitem)}
            </td>
            {/* 견적금액 */}
            <td className="text_center">
                <p className="pt-pay"><span className="font-mont">
                    {Number(curitem.es_detail_total_price.toFixed(1)).toLocaleString()}</span>원</p>
            </td>
        </EsReqDoneTrItemBlock>
    );
};

export default EsReqDoneTrItem;